module.exports = __webpack_public_path__ + "static/img/monogram-horizontal.b46cb5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monogram-horizontal.png
// module id = 303
// module chunks = 1